export const blobToBase64 = async (file: File): Promise<string> => {
    return new Promise((resolve, _) => {
        const reader = new FileReader();

        reader.onloadend = () => {
            if (reader.result === null) {
                throw new Error("Base64 encoding failed.");
            }

            resolve(reader.result.toString().split(",")[1]);
        };

        reader.readAsDataURL(file);
    });
};
